import { AssetIcon } from '@/shared/ui/Asset'
import { useResponsive } from '@/features/responsive/hooks/useResponsive.ts'

export function Logo() {
  const isTablet = useResponsive('tablet')

  return <AssetIcon filename={'logo.png'} size={isTablet ? 40 : 32} />
}
